module.exports = __webpack_public_path__ + "img/bottom-contact.bbe5a9bf.jpg";